import type { ServerPaginationConfig } from '@shared/types/module-config';

export const DCT_PAGINATION: ServerPaginationConfig = {
  enabled: true,
  mode: 'server',
  pageParam: 'page',
  sizeParam: 'size',
  defaultSize: 25,
  firstPage: 0,
  sendPageIfDefault: true,
};

export const DEBIT_CARD_ROUTE_PATHS = {
  debitCardTransactions: '/movements/debit-card-transactions',
};

export const DEBIT_CARD_API_PATHS = {
  transactions: '/v1/api/platform/debit-card/transaction',
  transactionDetail: '/v1/api/platform/debit-card',
  reverseTransaction: '/v1/api/platform/debit-card',
};

export const PROMO_REWARD_BASE_URL =
  'https://astropay.retool.com/editor/ba423c24-df09-11ef-ace6-7fe21c6d3233/Support%20Gateway/Promo%20Engine/promo-manual-reward';
